<!-- Move Hub Modal -->
<div class="modal fade" id="moveHubModal" tabindex="-1" aria-labelledby="moveHubModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="moveHubModalLabel">Move Hub</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <label for="hubIdSearch" class="form-label">Enter Hub ID</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              id="hubIdSearch"
              [(ngModel)]="hubIdToSearch"
              (ngModelChange)="onHubIdChange()"
              placeholder="Enter hub ID to search">
            <button
              class="btn btn-primary"
              type="button"
              [disabled]="!findButtonEnabled"
              (click)="findHub()">Find Hub</button>
          </div>
        </div>

        <div class="mb-3" *ngIf="statusText">
          <span class="badge text-bg-{{ statusTheme }}">{{ statusText }}</span>
        </div>

        <!-- Search Results -->
        <div *ngIf="searchPerformed && searchResults.length > 0" class="mb-3">
          <h6>Search Results:</h6>
          <ul class="list-group">
            <li *ngFor="let hub of hubsWithLocations" class="list-group-item">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <strong>Hub ID:</strong> {{ hub.hubId }}
                </div>
                <button class="btn btn-sm btn-primary" (click)="moveHub(hub.hubId)">Move</button>
              </div>
              <div *ngIf="hub.hasError" class="mt-1">
                <small class="text-danger">{{ hub.errorMessage }}</small>
              </div>
              <div *ngIf="!hub.hasError && hub.location" class="mt-1">
                <small class="text-muted">Location: {{ hub.location.label }}</small>
              </div>
              <div *ngIf="!hub.hasError && !hub.location" class="mt-1">
                <small class="text-muted">No location found for this hub</small>
              </div>
            </li>
          </ul>
        </div>

        <div *ngIf="searchPerformed && searchResults.length === 0" class="mb-3">
          <p>No hubs found matching the search criteria.</p>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Move Hub Confirmation Modal -->
<div class="modal fade" id="moveHubConfirmModal" tabindex="-1" aria-labelledby="moveHubConfirmModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="moveHubConfirmModalLabel">Confirm Hub Move</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>Confirm moving hub: {{ hubToMove }}</p>
        <p>from location:</p>
        <h5>{{ hubToMoveCurrentLocation }}</h5>
        <p>to location:</p>
        <h5>{{ selectedLocationLabel }}</h5>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeConfirmModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="confirmMoveHub()">Move Hub {{ hubToMove }}</button>
      </div>
    </div>
  </div>
</div>
